export default {
    name_ar:        'الاسم بالعربي',
    name_en:        'الاسم بالانجليزي',
    company_id:     'الشركة',
};
